var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrategyMindmap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 193,
    viewBox: "0 0 233 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_217_62)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 83,
    r: 36.5,
    fill: "#FF715B",
    stroke: "#FF715B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 38,
    r: 15.5,
    fill: "#F8F4A6",
    stroke: "#FF715B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 168,
    r: 15.5,
    fill: "#F8F4A6",
    stroke: "#FF715B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 17,
    r: 15.5,
    fill: "#F8F4A6",
    stroke: "#FF715B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 145,
    r: 15.5,
    fill: "#F8F4A6",
    stroke: "#FF715B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.294,
    y1: 67.6765,
    x2: 198.294,
    y2: 43.6765,
    stroke: "#FF715B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.577,
    y1: 153.526,
    x2: 109.577,
    y2: 117.526,
    stroke: "#FF715B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 101,
    r: 15.5,
    fill: "#F8F4A6",
    stroke: "#FF715B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.6362,
    y1: 99.5448,
    x2: 84.6362,
    y2: 87.5448,
    stroke: "#FF715B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.776,
    y1: 53.867,
    x2: 80.776,
    y2: 29.867,
    stroke: "#FF715B",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.792,
    y1: 105.726,
    x2: 194.792,
    y2: 133.726,
    stroke: "#FF715B",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_217_62",
    x: 0,
    y: 0,
    width: 233,
    height: 193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_217_62",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyMindmap);
export default __webpack_public_path__ + "static/media/strategy-mindmap.3ffffc0333bb1815c1967b5652532e94.svg";
export { ForwardRef as ReactComponent };